import { useQuery } from '@tanstack/react-query';

import { type InstallationSubscription } from 'generated-sources';

import { queryKeys, useApi } from 'shared/api/model';

export const useInstallationSubscription = (installationId?: number) => {
  const api = useApi('BillingApi');

  return useQuery<InstallationSubscription | null>({
    queryKey: queryKeys.billing.subscription(installationId!).queryKey,
    queryFn: () =>
      api
        .getInstallationSubscription({ installationId: installationId! })
        .catch(() => null),
    enabled: !!installationId,
    staleTime: 5 * 60 * 1000, // 5 minutes - subscription rarely changes
    gcTime: 10 * 60 * 1000,
  });
};
